export const ADMIN_CONFIGURE_CODE_MACRO_ANALYTICS_SOURCE = 'adminConfigureCodeMacro';

export const DEFAULT_THEME_VALUE = 'Confluence';
export const DEFAULT_LANGUAGE_VALUE = 'Java';
